<template>
  <modal @close="$emit('close')">
    <p>Created, Programmed & Maintained by NeosteelEnthusiast.</p>
    <p>
      Main banner video, color theme & additional graphic assets by
      <a
        href="https://twitter.com/bodypop_"
        target="_blank"
      >Bodypop</a>.
    </p>
    <p>
      Additional graphic assets by
      <a
        href="https://twitter.com/nice__username"
        target="_blank"
      >nice__username</a>.
    </p>
    <p>
      iNcontroL portrait by
      <a
        href="https://twitter.com/nicolaschaussoi"
        target="_blank"
      >Nicolas Chaussois</a>.
    </p>
    <p>Default "Milo" avatar & marine heart emote property of Blizzard Entertainment.</p>
    <p>
      Icons from
      <a href="https://feathericons.com/" target="_blank">Feather Icons</a> &
      <a href="https://fontawesome.com/" target="_blank">Font Awesome</a>.
    </p>
    <p>
      Copyright footer background from
      <a
        href="https://www.heropatterns.com/"
        target="_blank"
      >Hero Patterns</a>.
    </p>
    <p>
      Additional development provided by
      <a href="https://twitter.com/FollowDiaXIs" target="_blank">Diaxis</a>.
    </p>
    <p>
      Special thanks to
      <a href="https://twitter.com/Artosis" target="_blank">Artosis</a>,
      <a href="https://twitter.com/CobraVe7nom7" target="_blank">CobraVe7nom7</a> and the entire Pylon Show team for making this possible.
    </p>
  </modal>
</template>

<script>
export default {
  name: "RichTextShortcutsModal"
}
</script>

<style scoped lang="scss">
a {
  @apply text-yellow-7;
}

a:hover {
  @apply text-yellow-6;
}

p {
  @apply mb-2;
}
</style>
